import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { IEnrolledStatus } from './model/verification.model';
import { ITenantInfo, IEnrolledState, IConfigureResponse } from './module/shared/model/IMfa.model';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss'],
})
export class VerificationComponent implements OnInit, OnDestroy {
  @Input() verificationType!: string|null;
  @Input() configdata!: ITenantInfo|any;
  @Input() trackId!:string|null;
  @Output() getEnrolledState = new EventEmitter();
  configData$ = new BehaviorSubject<ITenantInfo>(<ITenantInfo>{});
  destroy$ = new Subject();
  track_id!: string;


  buttonOpt = {
    color: 'accent',
    text: 'SUGGESTED_VERIFICATION_METHOD.ASK_AGAIN',
    alignment: 'right',
    type: 'proceed',
    underline: 'none',
    for: 'cidaasSubmitBtn',
    translateArgs: {},
    style: 'secondary',
  };

  enrolledStatus: IEnrolledState = <IEnrolledState>{};

  constructor() {}


  ngOnInit(): void {
    this.configData$.next(this.configdata as ITenantInfo);
    this.track_id = this.trackId as string;
  }

  ngOnDestroy(): void {
      this.destroy$.next();
  }

  _checkEnrollmentStatus = (e:IEnrolledState) => {
    switch (e.status) {
      case 'error':
        this.getEnrolledState.emit(this._generateEnrollmentStatus(false, e?.data));
        break;
      case 'completed':
        this.getEnrolledState.emit(this._generateEnrollmentStatus(true, e?.data));
        break;

      default:
        this.getEnrolledState.emit(this._generateEnrollmentStatus(false, e?.data));
        break;
    }
  };

  _generateEnrollmentStatus = (enrolled: boolean, enrolmentStatus: IConfigureResponse): IEnrolledStatus => {
    return <IEnrolledStatus>{ enrolled: enrolled, type: this.verificationType, enrolmentStatus: enrolmentStatus };
  };
}
